<template>
    <div class="left">
        <div class="left-content">
            <div class="content-title">经营主体统计</div>
            <div class="content-c">
                <div class="tools" v-if="this.$parent.townId === '0'">
                    <a-select v-model:value="bodySelectValue" style="width: 100px" @change="handleChange">
                        <template #suffixIcon><caret-down-outlined style="color: #071A37"/></template>
                        <a-select-option :value="'-1'" :key="20">商河县</a-select-option>
                        <a-select-option v-for="(item, i) in this.$utils.townList" :value="item.name" :key="i">{{ item.name }}</a-select-option>
                    </a-select>
                </div>
                <charPie1
                    ref="chartPie1"
                    c-id="chartPie1"
                    :customer-style="cusStyle1"
                ></charPie1>
            </div>
        </div>
        <div class="left-content">
            <div class="content-title">供需服务发布统计</div>
            <div class="content-c">
                <div class="tools">
                    <a-space>
                        <a-date-picker v-model:value="dataStatisticsValue.dataStatisticsDate"  style="width: 120px"/>
                        <a-select v-model:value="dataStatisticsValue.dataStatisticsSelectValue" style="width: 100px" @change="supplyChange">
<!--                            <template #suffixIcon><caret-down-outlined style="color: #071A37"/></template>-->
                            <a-select-option :value="'all'">全部</a-select-option>
                            <a-select-option v-for="(item, i) in this.$utils.getNearTwelveMonth()" :value="item" :key="i">{{ item }}</a-select-option>
                        </a-select>
                    </a-space>
                </div>
                <chartLine1
                    ref="chartLine1"
                    c-id="chartLine1"
                    :chart-data="supplyChartData"
                    :customer-style="cusStyle1"
                ></chartLine1>
            </div>
        </div>
        <div class="left-content">
            <div class="content-title">系统资源</div>
            <div class="content-c">
                <textLabel></textLabel>
            </div>
        </div>
    </div>
</template>

<script>
import charPie1 from "./charPie1"
import chartLine1 from "./chartLine1"
import textLabel from "./textLabel"
import { CaretDownOutlined } from '@ant-design/icons-vue'
import { reactive, ref } from 'vue'
import {getBodyStatisticsDataApi, getSupplyServiceStatisticsApi} from '@/api/visualization'

export default {
    name: "right",
    setup() {
        const townList = {
            '5162': '殷巷镇',
            '5163': '怀仁镇',
            '5164': '龙桑寺镇',
            '5165': '郑路镇',
            '5166': '贾庄镇',
            '5167': '玉皇庙镇',
            '5168': '白桥镇',
            '5169': '孙集镇',
            '5170': '韩庙镇',
            '5171': '沙河镇',
            '5172': '张坊镇',
            '6048': '许商街道',
            '0': '-1'
        }
        const cusStyle1 = 'width: 100%; height: 255px'
        const bodySelectValue = ref('') // 新型主体选择值
        const dataStatisticsValue = reactive({
            dataStatisticsDate: undefined,
            dataStatisticsSelectValue: 'all'
        }) // 供需数据统计
        const supplyChartData = reactive({})
        return {
            cusStyle1,
            bodySelectValue,
            dataStatisticsValue,
            supplyChartData,
            townList
        }
    },
    mounted() {
        this.bodySelectValue = this.townList[this.$parent.townId]
        // this.initWeather()
        this.getBodyStatisticsData('-1')
        this.getSupplyServiceStatisticsData(this.dataStatisticsValue.dataStatisticsSelectValue)
    },
    methods: {
        initWeather() {
            // this.$refs.chartLink.initChart()
        },
        async getSupplyServiceStatisticsData(date) {
            // const date = this.dataStatisticsValue.dataStatisticsDate ? this.dataStatisticsValue.dataStatisticsDate.format('YYYY-MM-DD') : this.$utils.getToday()
            const townId = this.$parent.townId === '0' ? '-1' : this.$parent.townId
            const res = await getSupplyServiceStatisticsApi(
                // townId + '/' + this.dataStatisticsValue.dataStatisticsSelectValue + '/'
                // townId + '/' + this.dataStatisticsValue.dataStatisticsSelectValue + '/' + date
                townId + '/' + date
            )
            const data = {data0: [], data1: [], name: []}
            const serviceData = res[0].服务
            const demandData = res[0].需求
            for (const i in demandData) {
                data.data0.push(demandData[i][1])
            }
            for (const i in serviceData) {
                data.data1.push(serviceData[i][1])
                data.name.push(serviceData[i][0])
            }
            // this.supplyChartData = data
            this.$refs.chartLine1.initChart(data)
        },
        async getBodyStatisticsData(params) {
            const res = await getBodyStatisticsDataApi(params)
            const data = []
            for (const i in res) {
                data.push({value: res[i][1], name: res[i][0]})
            }
            this.$refs.chartPie1.initChart(data)
        },
        handleChange(value) {
            this.getBodyStatisticsData(value)
        },
        supplyChange() {
            this.getSupplyServiceStatisticsData(this.dataStatisticsValue.dataStatisticsSelectValue)
        },
    },
    watch: {
        'dataStatisticsValue.dataStatisticsDate'() {
            this.getSupplyServiceStatisticsData(this.dataStatisticsValue.dataStatisticsDate.format('YYYY-MM-DD'))
        }
    },
    components: {
        charPie1,
        chartLine1,
        textLabel,
        CaretDownOutlined
    }
}
</script>

<style scoped lang="stylus">
    .left {
        width 480px
        position absolute
        z-index 1
        right 30px
        bottom 25px
        transition 0.3s
        .left-content {
            width 100%
            height 300px
            background-image url("../../assets/img/gis_window_bg_3.png")
            background-size 100% 100%
            margin-top 15px
            padding-top 9px
            .content-title {
                width 100%
                height 25px
                line-height 25px
                font-size 18px
                padding-left 60px
                color #3EF5FC
                font-family "Source Han Sans CN"
            }
            .content-c {
                width 100%
                height calc(100% - 25px)
                position relative
                .tools {
                    position absolute
                    right 27px
                    top 16px
                    z-index 1
                    /deep/ .ant-select-selector {
                        background #3EF5FC
                        border-radius 2px
                        color #071A37
                        border-color #3EF5FC
                    }
                    /deep/ .ant-select-selection-item {
                        color #071A37
                    }
                    /deep/ .ant-input {
                        border-color #3EF5FC
                        background #3EF5FC
                        color #071A37
                    }
                    /deep/ .ant-input::-webkit-input-placeholder {
                        color: #071A37
                    }
                    /deep/ .ant-calendar-picker-icon {
                        color: rgba(7, 26, 55, 0.5)
                    }
                }
            }
        }
    }
    @media (min-width: 1921px) {
        .left {
            width 680px
            .left-content {
                .content-title {
                    padding-left 80px
                }
            }
        }
    }
</style>